import React from "react";
import "./Loader.scss";
import classNames from "classnames";

const Loader = ({ width, height, loading, success, error }) => {
  return (
    <div className="custom-loader">
      <div className={classNames({ loading, success, error })}>
        {loading && (
          <svg
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            height={height}
            width={width}
          >
            <circle cx="50" cy="50" r="45" />
          </svg>
        )}
        {!loading && success && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="3 3 16 16"
            height={height}
            width={width}
          >
            <defs>
              <linearGradient
                gradientUnits="userSpaceOnUse"
                y2="-2.623"
                x2="0"
                y1="986.67"
              >
                <stop stopColor="#ffce3b" />
                <stop offset="1" stopColor="#ffd762" />
              </linearGradient>
              <linearGradient
                y2="-2.623"
                x2="0"
                y1="986.67"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#ffce3b" />
                <stop offset="1" stopColor="#fef4ab" />
              </linearGradient>
            </defs>
            <g
              transform="matrix(1.99997 0 0 1.99997-10.994-2071.68)"
              fill="#da4453"
            >
              <rect
                y="1037.36"
                x="7"
                height="8"
                width="8"
                fill="#32c671"
                rx="4"
              />
              <path
                d="m123.86 12.966l-11.08-11.08c-1.52-1.521-3.368-2.281-5.54-2.281-2.173 0-4.02.76-5.541 2.281l-53.45 53.53-23.953-24.04c-1.521-1.521-3.368-2.281-5.54-2.281-2.173 0-4.02.76-5.541 2.281l-11.08 11.08c-1.521 1.521-2.281 3.368-2.281 5.541 0 2.172.76 4.02 2.281 5.54l29.493 29.493 11.08 11.08c1.52 1.521 3.367 2.281 5.54 2.281 2.172 0 4.02-.761 5.54-2.281l11.08-11.08 58.986-58.986c1.52-1.521 2.281-3.368 2.281-5.541.0001-2.172-.761-4.02-2.281-5.54"
                fill="#ffffff"
                transform="matrix(.0436 0 0 .0436 8.177 1039.72)"
                stroke="none"
                strokeWidth="9.512"
              />
            </g>
          </svg>
        )}
        {!loading && error && (
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="3 3 16 16"
              width={width}
              height={height}
            >
              <defs>
                <linearGradient
                  gradientUnits="userSpaceOnUse"
                  y2="-2.623"
                  x2="0"
                  y1="986.67"
                >
                  <stop stopColor="#ffce3b" />
                  <stop offset="1" stopColor="#ffd762" />
                </linearGradient>
                <linearGradient
                  gradientUnits="userSpaceOnUse"
                  y1="986.67"
                  x2="0"
                  y2="-2.623"
                >
                  <stop stopColor="#ffce3b" />
                  <stop offset="1" stopColor="#fef4ab" />
                </linearGradient>
                <linearGradient gradientUnits="userSpaceOnUse" x2="1" x1="0" />
              </defs>
              <g transform="matrix(2 0 0 2-11-2071.72)">
                <path
                  transform="translate(7 1037.36)"
                  d="m4 0c-2.216 0-4 1.784-4 4 0 2.216 1.784 4 4 4 2.216 0 4-1.784 4-4 0-2.216-1.784-4-4-4"
                  fill="#da4453"
                />
                <path
                  d="m11.906 1041.46l.99-.99c.063-.062.094-.139.094-.229 0-.09-.031-.166-.094-.229l-.458-.458c-.063-.062-.139-.094-.229-.094-.09 0-.166.031-.229.094l-.99.99-.99-.99c-.063-.062-.139-.094-.229-.094-.09 0-.166.031-.229.094l-.458.458c-.063.063-.094.139-.094.229 0 .09.031.166.094.229l.99.99-.99.99c-.063.062-.094.139-.094.229 0 .09.031.166.094.229l.458.458c.063.063.139.094.229.094.09 0 .166-.031.229-.094l.99-.99.99.99c.063.063.139.094.229.094.09 0 .166-.031.229-.094l.458-.458c.063-.062.094-.139.094-.229 0-.09-.031-.166-.094-.229l-.99-.99"
                  fill="#ffffff"
                />
              </g>
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default Loader;
